import PropTypes from "prop-types";
import ButtonBase from "@mui/material/ButtonBase";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { figmaTokens } from "assets/theme/designTokens";

const styles = {
  all: { color: figmaTokens.accent, bg: "rgba(102, 126, 234, 0.12)", icon: "#667eea" },
  active: { color: "#047857", bg: "rgba(16, 185, 129, 0.12)", icon: "#10b981" },
  inactive: { color: "#b91c1c", bg: "rgba(239, 68, 68, 0.11)", icon: "#ef4444" },
};

function AccountStatusTabs({ value, onChange, counts, labels }) {
  return (
    <SoftBox
      role="tablist"
      aria-label="Account status"
      sx={{
        display: "inline-flex",
        flexWrap: "wrap",
        gap: 0.75,
        p: 0.6,
        borderRadius: "14px",
        bgcolor: "#f1f5f9",
        border: `1px solid ${figmaTokens.borderSubtle}`,
      }}
    >
      {["all", "active", "inactive"].map((status) => {
        const selected = value === status;
        const palette = styles[status];
        return (
          <ButtonBase
            key={status}
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(status)}
            sx={{
              minWidth: { xs: 96, sm: 116 },
              px: 1.4,
              py: 0.85,
              gap: 0.8,
              borderRadius: "10px",
              color: selected ? palette.color : figmaTokens.textSecondary,
              bgcolor: selected ? "#fff" : "transparent",
              boxShadow: selected ? "0 4px 14px rgba(15, 23, 42, 0.1)" : "none",
              transition: "all 0.18s ease",
              "&:hover": { bgcolor: selected ? "#fff" : "rgba(255,255,255,0.7)" },
            }}
          >
            <SoftBox
              component="span"
              sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: palette.icon, flexShrink: 0 }}
            />
            <SoftTypography component="span" variant="button" sx={{ color: "inherit", fontWeight: 700 }}>
              {labels[status]}
            </SoftTypography>
            <SoftBox
              component="span"
              sx={{
                minWidth: 24,
                height: 22,
                px: 0.7,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "999px",
                bgcolor: selected ? palette.bg : "rgba(100, 116, 139, 0.1)",
                color: selected ? palette.color : figmaTokens.textMuted,
                fontSize: "0.72rem",
                fontWeight: 800,
              }}
            >
              {counts[status] ?? 0}
            </SoftBox>
          </ButtonBase>
        );
      })}
    </SoftBox>
  );
}

AccountStatusTabs.propTypes = {
  value: PropTypes.oneOf(["all", "active", "inactive"]).isRequired,
  onChange: PropTypes.func.isRequired,
  counts: PropTypes.shape({ all: PropTypes.number, active: PropTypes.number, inactive: PropTypes.number }).isRequired,
  labels: PropTypes.shape({ all: PropTypes.string, active: PropTypes.string, inactive: PropTypes.string }).isRequired,
};

export default AccountStatusTabs;
